/* eslint-disable @typescript-eslint/no-explicit-any */
// any validate прописано так как валидация FileField не принимает асинхронные данные. Требуется асинхронная валидация

import React, { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { Button, FileField, Icon, ModifFile } from 'vetrf-ui';
import { FileFieldProps } from 'vetrf-ui/dist/components/form/fields/field/file/FileField/FileField';
import { FileType } from 'types/types';
import classNames from 'classnames';
import styles from './SingleFileUploadEdit.module.scss';

type FileInputProps = {
  name: string;
  labelText: string;
  uploadedFileName: string;
  acceptedFileTypes?: FileFieldProps['acceptedFileTypes'];
  fieldClassName?: string;
  labelClassName?: string;
  fileLink?: string;
  required?: boolean;
  validate?: (value: ModifFile[]) => any;
  maxFileSize?: FileFieldProps['maxFileSize'];
};

export const SingleFileUploadEdit = ({
  name,
  labelText,
  uploadedFileName,
  acceptedFileTypes,
  fileLink = '/files',
  fieldClassName,
  labelClassName,
  required,
  validate,
  maxFileSize,
}: FileInputProps) => {
  const { setValue, formState, getFieldState, trigger } = useFormContext();
  const { error } = getFieldState(name, formState);

  const fileField: FileType = useWatch({ name: uploadedFileName });

  const handleDelete = () => {
    setValue(uploadedFileName, undefined);
    setValue(name, undefined);
  };

  useEffect(() => {
    if (formState.isSubmitted && !fileField) trigger(name);
  }, [fileField, formState.isSubmitted]);

  return (
    <FileField
      name={name}
      labelText={labelText}
      fieldClassName={classNames(styles.fileUpload, fieldClassName)}
      labelClassName={labelClassName}
      disabled={!!fileField}
      required={required && !fileField && 'Необходимо заполнить поле'}
      acceptedFileTypes={acceptedFileTypes}
      additionalBlock={
        <>
          {fileField && (
            <div>
              <div className="mt-15" key={fileField.id}>
                <a href={`${fileLink}/${fileField.id}`}>
                  <Icon color="blue" icon="file" size={110} className="mr-10" />
                  {fileField.name}
                </a>
                <Button
                  icon="trash"
                  iconColor="red"
                  iconSize={110}
                  onClick={handleDelete}
                  onlyIcon
                  tooltip="Удалить файл"
                />
              </div>
            </div>
          )}
          {!!error?.message && (
            /**
             * исправление ошибки в FileField (библиотека vetrf-ui)
             * после манипуляциями с файлами резултаты фунции validate
             * перестают выводиться
             * TODO: перепроверить после обновления vetrf-ui
             */
            <p className="help-block form-group__error form-group__error--manual">
              {error.message}
            </p>
          )}
        </>
      }
      validate={validate}
      maxFileSize={maxFileSize}
    />
  );
};
